import { BrowserRouter, Routes, Route } from 'react-router';
import Layout from './components/Layout.jsx';
import Home from './pages/Home.jsx';
import Segp from './pages/Segp.jsx';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="segp" element={<Segp />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
